export default __webpack_public_path__ + "static/media/home_thumb_KH_.5fea2842.png";